import React from 'react';
import { Animated, View, ViewPropTypes, Dimensions, Platform } from 'react-native'
import LinearGradient from 'react-native-linear-gradient';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import ManualRefresh from '@vfgroup-oneplatform/foundation/Components/ManualRefresh';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import DashboardMainCards from '../components/DashboardMainCards';

import styles from './Dashboard.styles';
import { VFText } from '@vfgroup-oneplatform/foundation/Components'

class Dashboard extends React.Component {
  state = {
    cardsPosition: new Animated.Value(0),
  };

  componentDidMount() {
    const { onRefresh, refreshInterval, spaceType } = this.props;
    this.animateCardsPosition(spaceType);
    if (_isFunction(onRefresh) && refreshInterval) {
      this.onRefreshInterval = setInterval(onRefresh, refreshInterval);
    }
  }
  componentDidUpdate(prevProps) {
    const { spaceType } = this.props;
    const { spaceType: prevSpaceType } = prevProps;
    if (spaceType !== prevSpaceType) {
      this.animateCardsPosition(spaceType);
    }
  }
  componentWillUnmount() {
    clearInterval(this.onRefreshInterval);
  }
  animateCardsPosition(spaceType) {
    const { dashboardTopOffset } = this.props;
    const { cardsPosition } = this.state;
    const value = (spaceType === 0 ? -55 : 0) - dashboardTopOffset;
    Animated.timing(cardsPosition, {
      toValue: value,
      duration: 400,
      useNativeDriver: false,
    }).start();
  }
  render() {
    const {
      mainCards,
      discover,
      onRefresh,
      images,
      lastUpdateTime,
      setLastUpdateTime,
      lastUpdatedLoadingConfig,
      shimmerPlaceholderConfig,
      cardsLoading,
      hasShadow,
      theme,
      dashboardMainCardsContainerStyle,
      refreshTitleStatusKeys,
    } = this.props;
    const { cardsPosition } = this.state;
    const { isLoadingMainCard, isLoadingSecondaryCard, isLoadingThirdCard, isLoadingFourthCard } =
      cardsLoading;
    return (
      <Animated.View
        style={[
          {
            top: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? -55 : null,
            // paddingBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : '15%',
          },
          styles.background(theme),
        ]}
        testID={FrameworkTestKeys.dashboardAnimatedView}
      >
        <DashboardMainCards
          hasShadow={hasShadow}
          {...mainCards}
          cardsLoading={cardsLoading}
          dashboardMainCardsContainerStyle={dashboardMainCardsContainerStyle}
        />
        <View
          style={{
            width: '100%',
            alignItems: 'center',
            backgroundColor: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? theme.colors.backgroundColor : theme.colors.backgroundColor,
            paddingBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 64 : 0,
            paddingTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 12,
          }}>
          <ManualRefresh
            onRefresh={onRefresh}
            images={images}
            lastUpdateTime={lastUpdateTime}
            setLastUpdateTime={setLastUpdateTime}
            lastUpdatedLoadingConfig={lastUpdatedLoadingConfig}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            isLoading={
              isLoadingMainCard ||
              isLoadingSecondaryCard ||
              isLoadingThirdCard ||
              isLoadingFourthCard
            }
          />
        </View>
        {discover}

        {/* seperate linear gradient into two componenet as linear gradient doesn't appear  if it has big height and add background color to its container if the issue happens again  */}

      </Animated.View>
    );
  }
}
Dashboard.defaultProps = {
  theme: LightThemeColors,
  dashboardTopOffset: 0,
  cardsLoading: {
    isLoadingMainCard: false,
    isLoadingSecondaryCard: false,
    isLoadingThirdCard: false,
    isLoadingFourthCard: false,
  },
};
Dashboard.propTypes = {
  mainCards: PropTypes.object,
  discover: PropTypes.node,
  lastUpdatedLoadingConfig: PropTypes.array,
  shimmerPlaceholderConfig: PropTypes.object,
  cardsLoading: PropTypes.shape({
    isLoadingMainCard: PropTypes.bool,
    isLoadingSecondaryCard: PropTypes.bool,
    isLoadingThirdCard: PropTypes.bool,
    isLoadingFourthCard: PropTypes.bool,
  }),
  onRefresh: PropTypes.func,
  spaceType: PropTypes.number,
  lastUpdateTime: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.number,
    PropTypes.string,
  ]),
  setLastUpdateTime: PropTypes.func,
  refreshInterval: PropTypes.number,
  images: PropTypes.object,
  hasShadow: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  dashboardTopOffset: PropTypes.number,
  dashboardMainCardsContainerStyle: ViewPropTypes.style,
  refreshTitleStatusKeys: PropTypes.shape({
    updatedNow: PropTypes.string,
    sinceLastUpdate: PropTypes.string,
  }),
};

export default withTheme(Dashboard);
